/**
 * core DOM elements
 * ? - $win.on() resize, scroll, hashchange, propstate 및
 * ?   offcanvas:activated (커스텀 이벤트) 등 어플 전체에 알려야 하는 상태 변화
 * ? - 기타 $body.on()로 했던 것들은 $doc.on()으로 하는 게 안정/성능면에서 좋음
 */
export const root = document.documentElement;
export const head = document.head;
export const body = document.body;

export const $win  = jQuery(window);
export const $doc  = jQuery(document);
export const $root = jQuery(root);
export const $html = $root; // $root와 동일하지만, 가독성을 위해 별칭 유지
export const $head = jQuery(head);
export const $body = jQuery(body);

/**
 * frequently used elements
 */
export const inputs = {
  get text() { return 'input[type=email], input[type=file], input[type=password], input[type=search], input[type=tel], input[type=text], input[type=url]'; },
  get textExt() { return `${this.text}, select`; },
  get textTxt() { return `${this.text}, textarea`; },
  get textAll() { return `${this.text}, select, textarea`; },
  get choice() { return 'input[type=checkbox], input[type=radio]'; },
  get all() { return `${this.choice}, ${this.textAll}`; },
};
export const $inputs = {
  get text() { return jQuery(inputs.text); },
  get textExt() { return jQuery(inputs.textExt); },
  get textTxt() { return jQuery(inputs.textTxt); },
  get textAll() { return jQuery(inputs.textAll); },
  get choice() { return jQuery(inputs.choice); },
  get all() { return jQuery(inputs.all); },
};